/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useQuery} from "react-query";
import {KTIcon} from "../../../../_metronic/helpers";
import {separateFormatter} from "../../../utils/separateFormatter";
import phoneFormatter from "../../../utils/phoneFormatter";
import {EmptySection} from "../empty/Empty";
import {LoaderSection} from "../loader/Loader";
import {getUsers} from "../../../services/userSvc";
import imgBaseUrl from "../../../utils/imgBaseUrl";

type Props = {
  className?: string
  items?: number
}

const TopUsersSection: React.FC<Props> = ({className, items = 6}) => {
  const {
    data: usersData,
    isLoading: usersIsLoading,
  } = useQuery(["getUsers"], () => getUsers({params: {top:true}}))

  return (
      <div className={`card card-xl-stretch mb-xl-8 ${className}`}>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold text-dark'>Eng ko'p murojaat qilganlar</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Xavf ostidagi foydalanuvchilar</span>
          </h3>
        </div>
        <div className='card-body pt-5'>
          {usersIsLoading ? <LoaderSection height={"30vh"}/> : !usersData || usersData?.data?.length === 0 ?
              <EmptySection height={"30vh"}/> :
              usersData && usersData?.data?.map((user, index) => (
                  <div key={index} className={`d-flex align-items-sm-center ${
                      index === items - 1 ? '' : 'mb-5'
                  }`}>
                    <div className='symbol symbol-50px me-5'>
            <span className='symbol-label'>
              {user?.avatar ? <img
                      src={imgBaseUrl(user?.avatar)}
                      className='h-50 align-self-center'
                      alt=''
                  /> :
                  <KTIcon iconName={"user"} className={"fs-1"}/>}
            </span>
                    </div>
                    <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                      <div className='flex-grow-1 me-2'>
                      <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                        {user?.first_name} {user?.last_name}
                      </span>
                        <a href={user?.email ? `mailto:${user?.email}` : `tel:+998${user?.phone}`}
                           className='text-muted fw-semibold d-block fs-7'>{user?.phone ? phoneFormatter(`998${user?.phone}`) : user?.email}</a>
                      </div>
                      <span
                          className='badge badge-light fw-bold my-2'>{separateFormatter(user?.sos_count, " ", "marta")}</span>
                    </div>
                  </div>
              ))
          }
        </div>
      </div>
  )
}

export {TopUsersSection}
